<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Vincular Compradores"
    @click:primary="salvarVinculacao"
  >
    <template #ativador>
      <v-badge bordered color="white" overlap>
        <template #badge>
          <span style="color: #000000">{{ selects.secoes.length }}</span>
        </template>

        <v-btn
          color="primary"
          small
          @click="dialog_ativo = true"
        >
          Vincular Compradores
        </v-btn>
      </v-badge>
    </template>

    <SysSecaoAutocomplete
      v-model="selects.secoes"
      label="Selecione as seções"
      multiple
      outlined
      :qtde-visivel-selecionados="1"
      :error-messages="secoesErrors"
      @input="$v.selects.secoes.$touch()"
      @blur="$v.selects.secoes.$touch()"
    />

    <SysCompradorAutocomplete
      v-model="selects.comprador"
      label="Selecione o comprador"
      outlined
      class="mb-n3"
      desabilitarJoin
      :error-messages="compradorErrors"
      @input="$v.selects.comprador.$touch()"
      @blur="$v.selects.comprador.$touch()"
    />
  </SysDialog>
</template>

<script>
import SysCompradorAutocomplete from '@/components/utils/crud/SysCompradorAutocomplete'
import SysSecaoAutocomplete from '@/components/utils/crud/SysSecaoAutocomplete'
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue'
import { arrayColumn } from '@/helpers'
import { required } from "vuelidate/lib/validators"
import { vincularSecoesAoComprador } from "@/api/Secoes"

export default {
  components: {
    SysCompradorAutocomplete,
    SysSecaoAutocomplete,
    SysDialog
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: Boolean,
    secoes_datadable_selecionada: Array
  },
  data: () => ({
    selects: {
      secoes: [],
      comprador: "",
    },
  }),
  computed: {
    dialog_ativo: {
      get(){
        return this.modelValue;
      },
      set(valor){
        this.$emit('update:modelValue', valor)
      }
    },
    secoesErrors() {
      const errors = [];
      if (!this.$v.selects.secoes.$dirty) return errors;
      !this.$v.selects.secoes.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    compradorErrors() {
      const errors = [];
      if (!this.$v.selects.comprador.$dirty) return errors;
      !this.$v.selects.comprador.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    }
  },
  validations: {
    selects: {
      secoes: {
        required,
      },
      comprador: {
        required,
      }
    }
  },
  watch: {
    secoes_datadable_selecionada() {
      if(this.secoes_datadable_selecionada.length > 0) {
        this.selects.secoes = arrayColumn(this.secoes_datadable_selecionada, 'idsecao').map(item => String(item));
      } else {
        this.selects.secoes = []
      }
    },
    dialog_ativo() {
      if(this.dialog_ativo) {
        const item = this.secoes_datadable_selecionada.find(item => item.idcomprador > 0);
        this.selects.comprador = item ? item.idcomprador : '';
      }

      if(!this.dialog_ativo)  {
        this.$v.$reset();
        this.selects.secoes = [];
        this.selects.comprador = "";
        this.$emit("dialog-fechado", {});
      }
    }
  },
  methods: {
    salvarVinculacao() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        secoes: this.selects.secoes,
        idcomprador: this.selects.comprador
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        vincularSecoesAoComprador(parametros)
        .then(() => {
          this.dialog_ativo = false;
          this.$emit('update:secao');
        })
        .catch(() => {
            this.Helpers.logout();
          })
      );
    },
  },

}

</script>

<style>

</style>
